export default {"src":"/_next/static/media/app-store_badge_ar.d1f4a14d.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};